import Reveal from "./Reveal";

/* Narrative ribbon between homepage feature blocks. */
export default function LeadIn({ kicker, title, text, testId }) {
  return (
    <Reveal className="leadin-wrap">
      <div className="leadin" data-testid={testId}>
        <span className="leadin-line" aria-hidden="true" />
        <div className="leadin-body">
          {kicker && <span className="section-tag">{kicker}</span>}
          <h2 className="leadin-title">{title}</h2>
          <p className="leadin-text">{text}</p>
        </div>
        <span className="leadin-line" aria-hidden="true" />
      </div>
    </Reveal>
  );
}
